import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    Platform
} from 'react-native';
import {
    JDTouchable,
    JDText,
    JDScrollView,
    JDImage,
    JDPopupWindow,
    JDJumping,
    JDPasswordDialog,
    JDAlertDialog,
    JDNativeSystem,
    JDMta,
    JDButton
} from '@jdreact/jdreact-core-lib';
import { Label, utils } from '@ltfe/ltfe-core-lib';
import img from '../common/img';
import st from '../style/order.st';
import { get, post, signPost } from '../common/fetch';

import {
	mta,
	mtaPV,
	complement,
	getWeek,
	diff,
	trim_time,
	tip,
	sub,
	mul,
	add,
	encrypt,
	routeDecryption,
	isWeb,
	decrypt,
	trimTime, fetchLocal
} from '../common/utils';
import { md5 } from '../common/md5';

import YingDou from '../components/common/yingdou';
import Jdbeans from '../components/common/jdbeans';
import Loading from '../components/common/loading';
import CountDown from '../components/common/count-down';
import PriceInfo from '../components/order/price-info';
import CouponList from '../components/coupon/coupon-checkbox-couponJ';
import LigntLicence from '../components/common/light-licence';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import WifiOut from '../components/common/wifi-out';
import { promoTxt } from '../common/enum';
import {agreementText} from '../config/protocol'
import GroupBuyingRule from '../components/groupBuyingRule';

import call from '@jd/call/lib';
// 接入辅营
import StandingOutsideCoupon from '../components/order/standing-outside-coupon';
import JDFinger from '@jdreact/jdreact-plugin-fingerprint';
import { setLog } from '../common/log';
import TicketPurchaseNotice from '../components/order/ticketPurchaseNotice';
import sgmReport from '../common/sgmUtil';

const { ShortPasswordDialog } = JDPasswordDialog;

const { pt, store } = utils;

const errMsg = {
    5000: '系统有点忙，请稍后重试',
    6001: '系统有点忙，请稍后重试',
    2100: '系统没有找到这个订单，请联系客服400-616-5718',
    2102: '订单金额有误，请联系客服400-616-5718',
    2300: '支付密码错误，请核对后重新输入',
    2201: '优惠券金额有误，请核对后重新提交或联系客服400-616-5718',
    2301: '在线支付金额有误，请核对后重新提交或联系客服400-616-5718',
    2302: '京豆金额错误，请核对后重新提交或联系客服400-616-5718',
    2108: '兑换券支付已达上限，请选择其他支付方式',
    6000: '商家数据更新，点击确定请重新选择',
    1000: '系统有点忙，请稍后重试',
    1001: '系统有点忙，请稍后重试',
    1002: '系统有点忙，请稍后重试',
    2101: '页面操作超时，点击确定更新订单状态',
    2103: '操作太快了，休息一下再试试',
    2104: '此订单已经提交过了哦，去首页再看看吧',
    2025: '兑换券使用异常，请重新选择'
};

const hostUrl = location.origin;

class Order extends Component {
    constructor(props) {
        super(props);
        const _state = {
            loading: false,

            /* 订单详情 */
            orderInfo: {},
            // 所有电影卡使用次数总和
            cardUseNum: 0,

            // 影豆降级标志位
            isYingDouError: false,
            // 影豆使用开关
            isUsedYingDou: false,
            // 影豆总数
            allYingDouCount: 0,
            // 当前订单可用影豆个数
            yingdouCount: 0,

            // 京豆使用开关
            isUsedJDbeans: false,
            // 京豆总数（全站）
            allJdbeans: 0,
            // 京豆当前订单可用个数
            jdbeansNum: 0,
            // 京豆已使用次数（用于京豆是否可用，>=3 今日使用已达上限）
            jdbeansCount: 0,
            // 京东豆接口降级处理
            isJdbeansError: false,

            // 在线支付金额
            onlinePayFee: 0,
            // 总金额
            totalFee: 0,
            // 每个座位减去促销后的价格
            paySeatPrice: 0,
            // 促销金额
            scaleFee: 0,

            /* 获取的优惠券列表 */
            couponList: null,
            // 优惠券总金额
            allCouponDiscount: 0,
            // 已选优惠券
            coupon: null,
            // 优惠券弹窗开关
            couponSelectShow: false,
            // 优惠券超出提示开关
            couponAllShow: false,
            // 优惠券接口是否异常
            isCouponError: false,

            // 价格明细弹层开关
            infoShow: false,
            // 支付密码
            passwordShow: false,
            // 支付超时，返回
            goList: true,

            /* 密码相关 start */
            errorMessage: null,
            inLoading: false,
            limitCount: 4,
            /* 倒计时 */
            minutes: 0,
            seconds: 0,
            // 错误编号
            errCode: 5000,
            // 供应商编号
            venderId: '',
            // 供应商名称
            venderName: '',
            // 是否显示营业执照
            isShowLicenceDialog: false,
            doSubmit: false,
            // 辅营活动信息
            userChoiceAcitves: [],
            // 设备指纹
            eid: '',
	          // 分区状态写入到 partition 内[]
	          partition: !!Number(props.partition),
		        moveidCardFee: 0,
            // 显示购票协议
            ticketPurchaseAgreement: false,
            // 协议
            agreementSure: true,
            // 显示协议弹窗
            showSignInfo: false,
            // 拼团电影
            isScheduledPlay: false
        };

        this.state = global.orderState || _state;

        this._openInfo = this._openInfo.bind(this);
        this._timeOut = this._timeOut.bind(this);
        // this._openScale = this._openScale.bind(this)
        this._setJdbeans = this._setJdbeans.bind(this);
        this._selectCoupon = this._selectCoupon.bind(this);
        this._onAgree = this._onAgree.bind(this);

        this._onHide = this._onHide.bind(this);
        this._goList = this._goList.bind(this);
        this.errFn = this.errFn.bind(this);

        this.checkSubmit = this.checkSubmit.bind(this);
        this._submit = this._submit.bind(this);
        this.refresh = this.refresh.bind(this);

        /* 密码验证 start */
        this.onClose = this.onClose.bind(this);
        this._submitShortPwd = this._submitShortPwd.bind(this);
        this._forgetPassword = this._forgetPassword.bind(this);
        /* 密码验证 end */

        this.toggleYinDouBtn = this.toggleYinDouBtn.bind(this);
        this.getOrder = this.getOrder.bind(this);
        this._getFingerEid = this._getFingerEid.bind(this);

        this.getOnlineFee = this.getOnlineFee.bind(this);

        this.getCoupon = this.getCoupon.bind(this);
        this.getJdbeans = this.getJdbeans.bind(this);
        this.getYingDou = this.getYingDou.bind(this);
        this._getCouponId = this._getCouponId.bind(this);
        this.getCard = this.getCard.bind(this);
        this.init = this.init.bind(this);
        this.getReOrder = this.getReOrder.bind(this);

        this.checkSubmitBefore = this.checkSubmitBefore.bind(this);
        this.checkSubmitForm = this.checkSubmitForm.bind(this);
        // 拼团电影
        this.handleScheduledPlay = this.handleScheduledPlay.bind(this);
    }

    render() {
        const {
            isUsedYingDou,
            isUsedJDbeans,
            orderInfo,
            couponList,
            onlinePayFee,
            coupon,
            allCouponDiscount,
            errorMessage,
            jdbeansNum,
            jdbeansCount,
            allJdbeans,
            totalFee,
            scaleFee,
            isCouponError,
            isJdbeansError,
            isYingDouError,
            allYingDouCount,
            yingdouCount,
	          hasError,
		        moveidCardFee,
            ticketPurchaseAgreement, // 购票协议
            agreementSure,
            isScheduledPlay
        } = this.state;
        const {
            minutes,
            seconds,
            errCode,
            cardUseNum,
            paySeatPrice
        } = this.state;
        const {
            infoShow,
            loading,
            couponSelectShow,
            inLoading,
            passwordShow,
            goList,
            isErrShow,
            doSubmit,
            couponAllShow
        } = this.state;
        const {
            venderId,
            isShowLicenceDialog,
            venderName,
	          partition
        } = this.state;
        const {
            mobileNum,
            price,
            theDate,
            startTime,
            activityType,
            planId,
            selectCertInfo,
            promoId,
            cardNum,
            seatsGroup,
            promoInfo,
            selectCertificateMap,
            promoDiscountPrice,
            scheduledPlay,
            govSubsidy,
            govSubsidyText, 
            govSubsidyTag
        } = this.props;

        /* 座位 */
        const seats = orderInfo?.seats?.split('|') || [];
        /* 可用优惠券数量 */
        const couponNum = couponList?.availableJCoupon?.length + couponList?.availableDCoupon?.length || 0;
        // 这里有可能传入空!!!
        const activityTypeActive = parseInt(activityType) >= 0;
        setLog().name('促销').add(activityType)
        // 分区后计算优惠总金额
        const totalPreferentialAmount = partition
          ? this.amountCalculation()
          : this.getCertFee()
        // 座位信息
        if (hasError) {
            return (
                <View style={ { flex: 1 } }>
                    <WifiOut refresh={ this.refresh } contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                </View>
            );
        }

        return (
            <View style={ st.container }>
                {
                    loading
                        ? <View style={ st.body }>
                            <JDScrollView style={ { flex: 1 } } keyboardDismissMode='on-drag' keyboardShouldPersistTaps='always' showsVerticalScrollIndicator={ false }>
                                {/* 影片信息 */}
                                <Info
                                    orderInfo={ orderInfo }
                                    startTime={ startTime }
                                    theDate={ theDate }
                                    seats={ seats }
                                    time={ { minutes, seconds } }
                                    timeOut={ this._timeOut } />

                                {/* 促销信息 */}
                                { activityTypeActive && scaleFee > 0 &&
                                    <Promotion activityType={ activityType } promotionFee={ scaleFee / 100 } govSubsidy={govSubsidy} govSubsidyText={govSubsidyText} govSubsidyTag={govSubsidyTag}/>
                                }
                                {/* 拼团规则 */}
                                {isScheduledPlay && <GroupBuyingRule />}
                                <View style={ st.scale_info }>
                                    {/* 电影兑换券入口 */}
                                    <Card
                                        goCardList={ () => {
                                            store.setItem('m-coupon', coupon);
                                            // store.setItem('m-jdbeans', jdbeans);
                                            store.setItem('selectCertInfo', selectCertInfo);
	                                          console.log('partition', partition)
                                            this.context.router.toMovieCardList({
                                                seatNum: seats.length,
                                                promoId: promoId || 0,
                                                mobile: mobileNum,
                                                planId,
                                                from: 1,
                                                partition: partition ? 1 : 0,
	                                              scheduledPlay
                                            });
                                            mta('OrdCouponExchan', 'OrdInput');
                                        } }
                                        cardNum={ cardNum }
                                        selectCardNum={ selectCertInfo.length }
                                    />

                                    {/* 优惠券入口 */}
                                    <Coupon
                                        selectCoupon={ this._selectCoupon }
                                        couponFee={ allCouponDiscount / 100 }
                                        couponNum={ couponNum }
                                        coupon={ coupon }
                                        cardUseNum={ cardUseNum }
                                        seatsCount={ seats.length }
                                        isCouponError={ isCouponError }
                                    />

                                    {/* 影豆 */}
                                    <YingDou
                                        isUsedYingDou={ isUsedYingDou }
                                        onlinePayFee={ onlinePayFee }
                                        limitCount={ jdbeansCount }
                                        yingdouCount={ yingdouCount }
                                        allYingDouCount={ allYingDouCount }
                                        toggleYinDouBtn={ this.toggleYinDouBtn }
                                        isYingDouError={ isYingDouError }
                                    />

                                    {/* 京豆 */}
                                    <Jdbeans
                                        jdbeans={ isUsedJDbeans }
                                        onlinePayFee={ onlinePayFee }
                                        jdbeansCount={ jdbeansCount }
                                        jdbeansNum={ jdbeansNum }
                                        allJdbeans={ allJdbeans }
                                        setJdbeans={ this._setJdbeans }
                                        coupon={ allCouponDiscount }
                                        cardUseNum={ cardUseNum }
                                        seatsCount={ seats.length }
                                        isJdbeansError={ isJdbeansError }
                                    />
                                </View>

                                {/* <Tel tel={decrypt(mobileNum,"y97c51kl38h8p144")} /> */}
                                <Tel tel={ mobileNum } />
                                {/* 接入辅营 */}
                                <StandingOutsideCoupon
                                    code={ 43 }
                                    businessLines="电影票"
                                    page="确认订单页"
                                    rules={ {
                                        cityId: this.props.cur_city.cityId,
                                        movieId: this.state.orderInfo.movieId,
                                        cinemaId: this.state.orderInfo.cinemaId,
                                        venderId: this.state.orderInfo.venderId,
                                        brand: this.props.brandId, //
                                        invalidateDate: this.props.theDate,
                                        planId: this.props.planId,
                                        newUser: this.props.newUser
                                    } }
                                    getCouponId={ (idData) => this._getCouponId(idData) }
                                />
                                {/* 门店信息 */}
                                <View style={ st.licence }>
                                    {
                                        venderId
                                            ? (
                                                <LigntLicence
                                                    dialogShow={ isShowLicenceDialog }
                                                    closeLicenceDialog={ () => this._closeDialog('isShowLicenceDialog') }
                                                    venderId={ venderId } />
                                            )
                                            : null
                                    }
                                    <JDText style={ st.licence_text }>本票品由{venderName}提供，</JDText>
                                    <JDTouchable onPress={ () => { this._showDialog('isShowLicenceDialog'); } }><JDText style={ st.blue }>查看证照信息</JDText></JDTouchable>
                                </View>
                                {/*购票协议*/}
                                <TicketPurchaseNotice />
                            </JDScrollView>
                            {/* 弹层 */}
                            <JDPopupWindow show={ infoShow || couponSelectShow } onHide={ this._onHide } height={ pt(couponSelectShow ? 450 : 410) }>

                                {/* 支付详情 费用明细 */}
                                {
                                    infoShow &&
                                    <PriceInfo
                                        scaleFee={ scaleFee / 100 }
                                        price={ price / 100 }
                                        count={ seats.length }
                                        cardUseNum={ cardUseNum }
                                        paySeatPrice={ paySeatPrice / 100 } // 没有使用
                                        onlinePayFee={ onlinePayFee / 100 }
                                        yingdouCount={ isUsedYingDou ? (yingdouCount / 100) : '' }
                                        jdbeans={ isUsedJDbeans ? (jdbeansNum / 100) : '0' }
                                        coupon={ allCouponDiscount / 100 || '0' }
                                        selectCertInfo={ selectCertInfo.length > 0 }
                                        selectCertInfoDetails={ selectCertInfo }
                                        promoDiscountPrice={ promoDiscountPrice }
                                        moveidCardFee={ moveidCardFee }
                                        seatsGroup={ seatsGroup }
                                        partition={ partition }
                                        promoInfo={ promoInfo }
                                        selectCertificateMap={ selectCertificateMap }
                                    />
                                }
                                {/* 优惠券 */}
                                {
                                    couponSelectShow &&
                                    <View style={ { backgroundColor: '#fff' } } height={ pt(450) }>
                                        <CouponList
                                            coupon={ coupon }
                                            fee={ onlinePayFee }
                                            usable={ couponList ? couponList.availableJCoupon.concat(couponList.availableDCoupon) : [] }
                                            unusable={ couponList ? couponList.unavailableJCoupon.concat(couponList.unavailableDCoupon) : [] }
                                            iscan={ couponList.flag }
                                            onHide={ this._onHide }
                                            onAgree={ this._onAgree }
                                        />
                                    </View>

                                }

                            </JDPopupWindow>
                        </View>
                        : <Loading contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                }

                {/* 密码输入 */}
                <ShortPasswordDialog
                    show={ passwordShow }
                    onClose={ this.onClose }
                    onSubmitPassword={ this._submitShortPwd }
                    inLoading={ inLoading }
                    errorMessage={ errorMessage }
                    onForgetPassword={ this._forgetPassword }
                />

                {/* 倒计时提示 */}
                <JDAlertDialog show={ !goList } onButtonClick={ this._goList }>
                    <View>
                        <JDText>订单支付超时，请您重新选择影片及场次</JDText>
                    </View>
                </JDAlertDialog>

                {/* 订单提交错误提示 */}
                <JDAlertDialog show={ isErrShow } okText={ +errCode === 2100 || +errCode === 2102
                    ? '返回首页'
                    : '确定' } onButtonClick={ this.errFn }>
                    <View>
                        <JDText>{errMsg[errCode]}</JDText>
                    </View>
                </JDAlertDialog>

                {/* 订单提交错误提示 */}
                <JDAlertDialog show={ couponAllShow } okText={ '知道了' } onButtonClick={ this._onHide }>
                    <View>
                        <JDText>优惠金额已超出实际支付金额，优惠券会浪费哦</JDText>
                    </View>
                </JDAlertDialog>

                {/*显示购票协议*/}
                {
                  ticketPurchaseAgreement && (<View style={ st.agreement_style }>
                      <View style={ st.panel }>
                          <View style={ st.agreement_top }>
                              <JDText style={ st.agreement_title }>退改签规定协议</JDText>
                              <JDScrollView style={ st.agreement_content }>
                                  <View dangerouslySetInnerHTML={{__html:agreementText() }} />
                              </JDScrollView>
                              <JDTouchable onPress={ () => this.agreementOremind() }>
                                  <View style={ st.agreement_oremind }>
                                      <JDImage
                                        source={{ uri: agreementSure ? 'https://img10.360buyimg.com/imagetools/jfs/t1/95834/25/36203/896/64b100afF65d388d3/4c752bf946c9032c.png' : 'https://img10.360buyimg.com/imagetools/jfs/t1/144656/28/36227/399/64b100afF5bd226d2/a1adc5d15d485531.png'}}
                                        style={ st.agreement_oremind_img } />
                                      <JDText style={ st.agreement_oremind_text }>不再提醒</JDText>
                                  </View>
                              </JDTouchable>
                              <JDButton onPress={ () => this.checkSubmitForm() } contentContainerStyle={ st.agreement_button }>
                                  我已同意以上协议并继续购票
                              </JDButton>
                          </View>
                          <JDTouchable onPress={ () => this.closeaGreement() } style={st.agreement_refuse}>
                            <JDText style={st.agreement_refuse_txt}>暂不购票</JDText>
                          </JDTouchable>
                      </View>
                      <View style={ st.agreement_opacity }></View>
                  </View>)
                }



                {
                    loading && !couponSelectShow &&
                    <Bottom
                        showInfo={ !infoShow }
                        price={ onlinePayFee }
                        doSubmit={ doSubmit }
                        submit={ this.checkSubmitBefore }
                        onlinePayFee={ onlinePayFee / 100 }
                        openInfo={ this._openInfo } />
                }

                <View style={ {
                    height: JDNativeSystem.iphoneXMarginBottom,
                    backgroundColor: '#fff',
                    width: '100%'
                } } />
            </View>
        );
    }

    init() {
        this.getOrder();
    }

    componentDidFocus() {
        const { theDate, startTime } = this.props;
        mtaPV('OrdInput', `__${theDate + ' ' + startTime}`);
    }

    /* 获取订单信息 */
    getReOrder(props, vb = null) {
        const { agentOrderId, agentId } = (props || this.props);
        const { userPin } = this.state;

        /* 影片信息 */
        get('getLockInfo', {
            agentOrderId,
            agentId,
            userPin
        }).then((res) => {
            global.orderRes = res;
	          vb && vb();
            // this.setState({
            //     loading: false,
            //     orderInfo: res.data,
            //     minutes: res.data.minutes,
            //     seconds: res.data.seconds,
            //     venderId: res.data.venderId || '',
            //     venderName: res.data.venderName || ''
            // });
        }).catch(() => {
            this.setState({
                hasError: true
            });
        });

        if(!agentOrderId || !agentId || !userPin){
            sgmReport('1001', {function_id: 'getLockInfo',message:'缺少参数agentOrderId/agentId/userPin'}, 3)
        }
    }

    componentDidMount() {
        this.getSignInfo();
	    if (!isWeb) {
          this.getOrder();
          this._getFingerEid();
	    }

	    if (isWeb) {
		    document.title = '确认订单';
		    this.setState({
			    loading: true
		    });

		    if (!global.orderState) {
			    this.getOrder();
			    this._getFingerEid();
		    }

		    if (!global.isFirst) {
			    global.isFirst = true;

			    call.event.on('order', () => {
				    global.orderIsReload = true;
				    this.getReOrder();
				    this._getFingerEid();
			    });
		    }
	    }
        this.handleScheduledPlay();
    }

    change = (prevProps) => {
	    const { totalFee, orderInfo, scaleFee, isUsedJDbeans, allCouponDiscount, paySeatPrice, isUsedYingDou } = this.state;
	    const {
	    		selectCertInfo,
			    promoDiscountPrice, // 单张优惠金额
			    promoSeatCount
	    } = this.props;
	    const seatLen = orderInfo?.seats?.split('|')?.length || 0;
	    let cardUseNum = 0;
	    let onlinePayFee = 0;
	    // 开启分区
	    selectCertInfo.forEach(card => { cardUseNum += Number(card.verifyingTimes); });
	    // paySeatPrice 每个座位减去促销后的价格 * 优惠券使用张数 = 优惠总金额
	    let moveidCardFee = 0;
	    // 开启分区
	    if (Number(prevProps.partition) === 1) {
		    moveidCardFee = this.getCertFee();
	    } else {
			    // 非分区支持金额计算
			    moveidCardFee = this.amountCalculation();
	    }
	    // 重新计算总价 用于请求优惠券和京豆金额  总价 - 电影卡金额
	    console.log('支付总金额', totalFee)
	    console.log('立减金额', scaleFee)
	    console.log('电影优惠券金额', moveidCardFee)
	    const remanentFee = this.getOnlineFee(totalFee, scaleFee, moveidCardFee);
	    if (selectCertInfo.length === seatLen) {
		    onlinePayFee = 0;
	    } else {
		    //  总金额 - 电影卡抵扣金额 - 促销
		    onlinePayFee = this.getOnlineFee(totalFee, scaleFee, moveidCardFee);
	    }

	    this.setState({
			    isUsedYingDou: false,
			    isUsedJDbeans: false,
			    coupon: null,
			    allCouponDiscount: 0,
			    onlinePayFee,
			    cardUseNum,
			    moveidCardFee
	    }, () => {
				// 促销后的金额 + 促销金额, 变回总金额;
		    this.getYingDou(totalFee);
		    this.getCoupon(remanentFee);
		    this.getJdbeans(remanentFee);
	    });

	    if ((isUsedYingDou || isUsedJDbeans || allCouponDiscount > 0) && cardUseNum !== seatLen) {
		    tip('由于应付金额发生变化，请重新选择支付方式');
	    }
    }

		componentDidUpdate(prevProps) {
			if (isWeb) {
				global.orderState = this.state;
				if (global.orderIsReload) {
					global.orderIsReload = false;
					setTimeout(() => {
						const res = global.orderRes;
						this.change(prevProps);
						this.setState({
							orderInfo: res.data,
							minutes: res.data.minutes,
							seconds: res.data.seconds,
							venderId: res.data.venderId || '',
							venderName: res.data.venderName || ''
						});
					}, 1200);
				}
			}
		}
    componentWillReceiveProps(nextProps) {
    //     // 单个电影卡兑换金额 = （ 总价 - 总促销 ）/ 座位数;

    //     const { totalFee, orderInfo, scaleFee, isUsedJDbeans, allCouponDiscount, paySeatPrice } = this.state;

    //     const seatLen = orderInfo.seats ? orderInfo.seats.split('|').length : 0;

    //     const selectCertInfo = nextProps.selectCertInfo;

    //     let cardUseNum = 0;

    //     let onlinePayFee;

    //     selectCertInfo.forEach(card => { cardUseNum += Number(card.verifyingTimes); });

    //     // 重新计算总价 用于请求优惠券和京豆金额  总价 - 电影卡金额
    //     const remanentFee = Number(sub(totalFee, mul(paySeatPrice, cardUseNum)));

    //     if (selectCertInfo.length === seatLen) {
    //         onlinePayFee = 0;
    //     } else {
    //         //  总金额 - 电影卡抵扣金额 - 促销
    //         onlinePayFee = Number(sub(sub(totalFee, scaleFee), mul(cardUseNum, paySeatPrice)));
    //     }

    //     this.setState({ isUsedJDbeans: false, coupon: null, allCouponDiscount: 0, onlinePayFee, cardUseNum }, () => {
    //         this.getCoupon(remanentFee);

    //         this.getJdbeans(remanentFee);
    //     });

    //     if ((isUsedJDbeans || allCouponDiscount > 0) && cardUseNum !== seatLen) {
    //         tip('由于应付金额发生变化，请重新选择优惠券或京豆');
    //     }
    }
    componentWillUnmount() {
    		global.orderState = this.state;
        // 删除缓存
		    localStorage.removeItem('certInfo'); // 券删除
	      localStorage.removeItem('selectCertInfo'); // 券删除
	      localStorage.removeItem('selectCertificateMap'); // 优惠删除
    }
		// 非分区支持金额计算 [电影兑换券抵扣金额计算]
		amountCalculation (){
				const {
						selectCertInfo,
						promoDiscountPrice, // 单张优惠金额
						promoSeatCount, // 有几张优惠
				} = this.props;
				const { orderInfo } = this.state
				// 座位数据
				const seats = orderInfo?.seats?.split('|') || [];
				const { paySeatPrice } = this.state;
				let moveidCardFee = 0; // 优惠总金额
				let cardUseNum = 0; // 选择卡张数
				let seatsNumber = seats.length; // 张数
				selectCertInfo.forEach(card => { cardUseNum += Number(card.verifyingTimes); });
				// 没有选择,直接返回 0
				if (cardUseNum === 0) return 0;
				// 优惠金额
				const discount = Number(promoDiscountPrice) > 0 ? Number(promoDiscountPrice) : 0;
				// 优惠个数
				const promoSeatCountNumber = Number(promoSeatCount);
				// 总共几张?
				// 若是有优惠, 排序抵扣最大的
				// 若是没有, 第一张
				// 生成价格对象
				const priceList = []
				for (var i = 0; i < seatsNumber; i++) {
						const isDiscount = (i < promoSeatCountNumber);
						priceList.push({
								price: (discount && isDiscount) ? (paySeatPrice - discount) : paySeatPrice,
								isDiscount
						})
				}
				// 有优惠个数表示价格不相等
				if (promoSeatCountNumber > 0) {
						// 根据价格高低进行排序
						priceList.sort((a,b) => b.price - a.price).map((value, index) => {
								// 计算优惠
								if (index < cardUseNum) moveidCardFee += value.price
						});
				} else {
						moveidCardFee = mul((paySeatPrice - discount), cardUseNum);
				}
				return moveidCardFee;
		}

    // 获取今日的协议弹窗状态
    getSignInfo() {
        get('movie_getSignInfo', {
            source: 1
        }, true).then((res)=> {
            // 显示弹窗条件, 已经签署过,并且没有勾选今日不再提醒;
            let showSign = res.success && !!(res?.data?.showFlag ?? true);
            this.setState({showSignInfo: showSign})
        })
    }

    // 影豆开关
    toggleYinDouBtn = () => {
        const {
            isUsedYingDou,
            paySeatPrice,
            cardUseNum,
            totalFee,
            scaleFee,
            yingdouCount,
            allCouponDiscount,
            isUsedJDbeans,
	          partition
        } = this.state;
        const cardFee = partition
          ? this.getCertFee()
          : this.amountCalculation();
        const tmpOnlieFee = this.getOnlineFee(totalFee, scaleFee, cardFee, !isUsedYingDou ? yingdouCount : 0);
        this.setState({
            isUsedJDbeans: false,
            coupon: null,
            allCouponDiscount: 0,
            onlinePayFee: tmpOnlieFee,
            isUsedYingDou: !isUsedYingDou
        }, () => {
            // 兑换券
            this.getCoupon(tmpOnlieFee);
            this.getJdbeans(tmpOnlieFee);
        });

        if (allCouponDiscount > 0 || isUsedJDbeans) {
            tip('由于应付金额发生变化，请重新选择支付方式');
        }
      // 销毁
      this.props.dispatch({ type: 'cert_info_change', certInfo: [] });
      this.props.dispatch({ type: 'select_certificate_map', certInfo: [] });
    }

    /* 确定选择优惠券 */
    _onAgree(coupon) {
        const {
            totalFee,
            isUsedJDbeans,
            scaleFee,
            jdbeansNum,
            isUsedYingDou,
            yingdouCount,
	          partition
        } = this.state;
        const { paySeatPrice, cardUseNum } = this.state;

        const cardFee = partition
          ? this.getCertFee()
          : this.amountCalculation();

        // 计算叠加优惠券总金额
        let allCoupon = 0;

        coupon.forEach(val => {
            allCoupon = allCoupon + val.discount;
        });
        const isCouponOverflow = allCoupon > totalFee - scaleFee - cardFee;

        // 超出给提示
        if (isCouponOverflow) {
            this.setState({
                couponAllShow: true
            });

            return;
        }
        // TODO:0
        const tmpOnlieFee = this.getOnlineFee(totalFee, scaleFee, cardFee, isUsedYingDou ? yingdouCount : 0, allCoupon, 0);
        // 优惠券批次号
        // TODO:选择优惠券后，是否重新加载京豆接口

        this.setState({
            isUsedJDbeans: false,
            couponSelectShow: false,
            coupon: coupon,
            allCouponDiscount: allCoupon,
            onlinePayFee: tmpOnlieFee
        }, () => {
            this.getJdbeans(tmpOnlieFee);
        });
        mta('OrdCouponItem', 'OrdInput', `${coupon ? coupon.batchId : ''}`);
        if (isUsedJDbeans) {
            tip('由于应付金额发生变化，请重新选择支付方式');
        }
    }

    /* 京豆开关 */
    _setJdbeans() {
        const {
            totalFee,
            isUsedJDbeans,
            jdbeansNum,
            scaleFee,
            allCouponDiscount,
            paySeatPrice,
            cardUseNum,
            allJdbeans,
            isUsedYingDou,
            yingdouCount,
	          partition
        } = this.state;

        // 开启分区后计算规则不同
        const cardFee = partition
            ? this.getCertFee()
            : this.amountCalculation(); // 计算兑换券金额
        /* 计算在线支付金额 */
        // TODO:0
        const tmpOnlieFee = this.getOnlineFee(totalFee, scaleFee, cardFee, isUsedYingDou ? yingdouCount : 0, allCouponDiscount, (!isUsedJDbeans ? jdbeansNum : 0));
        this.setState({
            isUsedJDbeans: !isUsedJDbeans,
            onlinePayFee: tmpOnlieFee
        });
        // 订单总金额_用户京豆总额_订单可用京豆总额_0/1（0：关闭，1：打开）
        mta('OrdJDBean', 'OrdInput', `${totalFee}_${allJdbeans}_${jdbeansNum}_${!isUsedJDbeans ? '1' : '0'}`);
    }

    /* 根据不同条件获取优惠后的金额
        uTotalFee: 总金额
        uSaleFee: 促销立减的金额
        uMovieCardFee: 电影兑换券金额
        uYingDouFee: 影豆金额
        uCouponFee: 京东优惠券金额
        uJDBeansFee: 京豆优惠金额
    */
    getOnlineFee(uTotalFee = 0, uSaleFee = 0, uMovieCardFee = 0, uYingDouFee = 0, uCouponFee = 0, uJDBeansFee = 0) {
        const uOnlinePayFee = uTotalFee - uSaleFee - uMovieCardFee - uYingDouFee - uCouponFee - uJDBeansFee;
        return uOnlinePayFee > 0 ? uOnlinePayFee : 0;
    }

    // 新的获取兑换券之后的金额
    getCertFee = () => {
	      try {
			    const selectCertificateMap = this.props?.selectCertificateMap || {};
		      console.log('兑换券详情', selectCertificateMap)
			    let certFee = 0;
		      // z转为数组进行操作
		      for (let x in selectCertificateMap) {
			      selectCertificateMap[x].map(item => certFee += item.price)
		      }
			    return certFee;
		    } catch (e) {
		      console.log('新的获取兑换券之后的金额错误', e)
			    return 0;
		    }
    }

    refresh() {
        this.setState({
            hasError: false,
            loading: false
        });
        this.getOrder();
    }

    // 获取已选择的辅营券
    _getCouponId(idData) {
        const userChoiceAcitves = [];

        idData.forEach(v => {
            const idDataJson = {};

            idDataJson.activeId = v;
            idDataJson.goodsCount = 1;
            userChoiceAcitves.push(idDataJson);
        });
        this.setState({
            userChoiceAcitves
        });
    }

    // 获取设备指纹
    _getFingerEid() {
        try {
            // 如果在金融App或商城App打开，需要获取设备原生信息，建议使用以下方法，返回字段详见下方列表
            // riskObj = getEidJoint();
            const riskObj = window?.getJdEid();
            const Eid = riskObj?.eid || '';

            this.setState({ eid: Eid });
        } catch (e) {
            this.setState({ eid: '' });
        }
    }

    // 订单支付超时，重新选择影片及场次
    _goList() {
        const { orderInfo } = this.state;

        const { theDate } = this.props;

        // return
        this.setState({
            goList: true
        });

        window.location.replace(`${hostUrl}/movieList?cinemaId=${orderInfo.cinemaId}&movieId=${orderInfo.movieId}&theDate=${theDate}`);
    }

    /* 忘记密码 */
    _forgetPassword() {
        this.setState({
            passwordShow: false
        });

        const url = 'https://msc.jd.com/payPwd/loginpage/wcoo/toShortForget?source=15&active=203';

        JDJumping.jumpToWeb(url).catch(err => tip(err));
    }

    /* 密码关闭 */
    onClose() {
        this.setState({
            passwordShow: false
        });
    }



    agreementOremind(){
        this.setState({ agreementSure: !this.state.agreementSure });
    }
    closeaGreement(){
        this.setState({ ticketPurchaseAgreement: false });
        this.context?.router?.goBack()
    }
    checkSubmitBefore(){
        if (this.state.showSignInfo) {
            this.setState({ ticketPurchaseAgreement: true });
        } else {
            this.checkSubmit();
        }

    }
    // 购票协议;
    checkSubmitForm(){
        // 保存接口;
        // 今日不再提醒: agreementSure
        post('movie_sign', {
            source: 1,
            closeRemind: this.state.agreementSure ? 1 : 0
        }, true).then((res) => {
            if (res.success) {
                // 关闭弹窗
                this.setState({ ticketPurchaseAgreement: false });
                // 若是选择了今日不提醒,则这里变成 false, 后退不再显示;
                this.setState({showSignInfo: !this.state.agreementSure})
                this.checkSubmit();
            } else {
                tip(res.errMsg)
            }
        })
    }

    /* 检查订单 */
    checkSubmit() {
        const { isUsedYingDou, isUsedJDbeans, coupon, orderInfo, jdbeansNum } = this.state;
        const { selectCertInfo, jskuId, rfId } = this.props;
        const errorMessage = selectCertInfo.length ? '兑换券使用后无法退回，确认无误请输入支付密码' : '';
        const hasCard = selectCertInfo.length > 0;
        const hasCouponJ = coupon && coupon.some((val) => {
            return (+val.type === 0);
        });
        // 使用了兑换券，或者影豆，或者京券，或者京豆
        if (isUsedYingDou || isUsedJDbeans || hasCouponJ || hasCard) {
            this.setState({
                inLoading: false,
                passwordShow: true,
                errorMessage
            });
        } else {
            this._submit();
        }
        // cinemaID_电影票sku_movieID_ErpOrderID_促销ID（若多个则用英文逗号拼接）_优惠券批次号_京豆使用数量（未使用时报0）
        mta('OrdSubmit', 'OrdInput', `${orderInfo.cinemaId}_${jskuId}_${orderInfo.movieId}_${'ErpOrderId'}_${hasCard ? null : rfId}_${coupon ? coupon.batchId : null}_${isUsedJDbeans ? jdbeansNum : 0}`);
    }

    _submit(password) {
        const {
            seatsGroup,
            agentOrderId,
            mobileNum,
            planId,
            userPin,
            rfId,
            limitNumber,
            jskuId,
            selectCertInfo,
            promoId,
            doSubmit,
            promoInfo,
            selectCertificateMap,
            promoDiscountPrice,
		        promoSeatCount,
	          scheduledPlay
        } = this.props;

        const {
            onlinePayFee,
            totalFee,
            coupon,
            jdbeansNum,
            scaleFee,
            isUsedJDbeans,
            allCouponDiscount,
            eid,
            isUsedYingDou,
            yingdouCount,
	          partition
        } = this.state;

        const { paySeatPrice, cardUseNum } = this.state;

        this._onHide();

        if (doSubmit) {
            tip('订单正在提交哦，请稍候');
            return;
        }

        this.setState({
            doSubmit: true
        });
        const couponIds = [];

        coupon && coupon.forEach((val) => {
            couponIds.push(val.id);
        });


        let certFee = 0;
        // 开启兑换券后的优惠金额计算
        if (partition) {
            certFee = this.getCertFee();
        } else {
		        // 需要减去优惠 [非分区支付金额计算]
		        certFee = this.amountCalculation();
        }
		    console.log('selectCertInfo', selectCertInfo);
        const totalFeeNumber = sub(sub(totalFee, certFee), isUsedYingDou ? yingdouCount : 0)
        const mob = JSON.parse(localStorage.getItem('savemobile'));
        const buyFrom = sessionStorage.getItem('buyFrom');
        const channel = sessionStorage.getItem('channel');

        let feSeat;

        if (seatsGroup?.length) {
            seatsGroup.sort((a, b) => {
                return a["price"] - b["price"];
            });
            feSeat = seatsGroup[0]?.["meta"];
        }

        const submitInfo = {
            feSeat,
            // 设备指纹
            eid: eid,
            // 供应商订单号
            agentOrderId: agentOrderId,
            // 京东放映计划ID
            planId: planId,
            // 手机号
	          mobileNum: mob,
            // 总金额, 这里面减去了影豆卡数量
            totalFee: totalFeeNumber,
            // 在线支付金额
            onlinePayFee: onlinePayFee,
            // 总扣减金额 TODO:是否把影豆纳入其中？
            totalDiscount: add(add(scaleFee, allCouponDiscount), isUsedJDbeans ? jdbeansNum : 0),
            // 电影卡抵扣金额
            certFee,
            // 用户名
            userPin: userPin,
            // 支付密码
            payPassword: password,
            // 京豆使用数量
            beanQuantity: isUsedJDbeans ? jdbeansNum : 0,
            // 影豆使用
            movieBeanQuantity: isUsedYingDou ? yingdouCount : 0,
            // 促销活动id
            // promoId: hasCard ? null : promoId,
            promoId: promoId || null,
            // 促销优惠价格
            // promoDiscountPrice: hasCard ? null : scaleFee,
            promoDiscountPrice: scaleFee || null,
            // 单品促销活动id
            // rfId: hasCard ? null : rfId,
            rfId: rfId || null,
            // 存在商家优惠时，传入值
            // limitNumber: hasCard ? null : limitNumber,
            limitNumber: limitNumber || null,

            // skuId: hasCard ? null : jskuId,
            skuId: jskuId || null,

            // 电影卡 没用卡为[]
            certInfo: selectCertInfo,
            // 优惠券集合
            /*******************************************************************/
            // 后端需要改成'ID,ID,ID'这种格式, 当前只能单选所以只选择id
            couponIds: couponIds.length > 0 ? couponIds.join(',') : '',
            /*******************************************************************/
            // 优惠券金额
            couponDiscount: allCouponDiscount,

            // 来源 默认 9
            buyFrom: +(buyFrom || 9),
            // 渠道信息 默认1
            channel: +(channel || 1),
            // 辅营活动
            assistInfo: {
                rules: {
                    cityId: this.props.cur_city.cityId,
                    movieId: this.state.orderInfo.movieId,
                    cinemaId: this.state.orderInfo.cinemaId,
                    venderId: this.state.orderInfo.venderId,
                    brand: this.props.brandId,
                    invalidateDate: this.props.theDate,
                    planId: this.props.planId,
                    newUser: this.props.newUser
                },
                userChoiceAcitves: this.state.userChoiceAcitves

            },
		        // 优惠券及座位信息[只保留有用的用户]
		        promoInfo: promoInfo.filter(value=> value.showPromotions),
		        promoSeatCount: Number(promoSeatCount),
	          scheduledPlay: +scheduledPlay
        };

        setLog().name('确认支付').add(submitInfo);
        signPost('submit', submitInfo).then((res) => {
            setLog().name('支付返回').add(res);
            this.setState({
                doSubmit: false
            });
            const code = res.errCode;
            if (code > 0) {
                // let code = res.errCode
                // 系统异常、网络异常 tip提示
                if (code === 5000 || code === 6001 || code === 2103 || code === 2025) {
                    if (code === 2025) { // 风控新增 提单被风控 重置兑换券
                        // this.props.dispatch({
                        //     type: 'cert_info_change',
                        //     certInfo: []
                        // });
                        // this.props.dispatch({
                        //     type:'cert_num_change',
                        //     cardNum: 0,
                        // })
                        // saveLocal('selectCertInfo',[])
                        this.init();
                    }
                    tip(errMsg[code]);
                    return;
                }
                // 其它错误弹层提示 this.errFn有对应错误说明
                this.setState({
                    errCode: code,
                    isErrShow: true
                });
                return;
            }
            if (res.data && res.data.erpOrderId) {
                // 订单上报存sku
                // JDMta.savePageInfoWithSKU(`${res.data.skuList.join(',')}`)
                // 订单上报
                try {
                    const orderData = {
                        orderId: `${res.data.erpOrderId}`,
                        factPrice: `${onlinePayFee}`, // 单位（元）
                        order_type: 'movie_order',
                        eventID: 'OrdInput'
                    };
                    if (Platform.OS === 'ios') {
                        orderData.prod_id = res.data.skuList.length > 0 ? `${res.data.skuList.join(',')}` : '000000000000';
                        orderData.sku_count = '1'; // ios string
                    } else {
                        orderData.skuId = res.data.skuList.length > 0 ? `${res.data.skuList.join(',')}` : '000000000000';
                        orderData.count = 1; // android number
                    }
                    JDMta.sendVirtualOrder(orderData);
                    // "sku_count": '1',
                    // "prod_id": res.data.skuList ? `${res.data.skuList.join(',')}` : '',
                    // "ord_ext": {}
                } catch (e) {
                }
                // "sku_count": '1',
                // "prod_id": res.data.skuList ? `${res.data.skuList.join(',')}` : '',
                // "ord_ext": {}
            }

            if (res.data.payUrl) {
                JDJumping.jumpToWeb(res.data.payUrl).catch(err => tip(err));
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                doSubmit: false
            });
        });

        if(!agentOrderId){
            sgmReport('1001', {function_id: 'submit',message:'缺少参数agentOrderId'}, 3)
        }

    }

    // 点击确定
    errFn() {
        const { errCode } = this.state;

        console.log(errCode);
        // 点击刷新的错误 数据更新、下单开关、京豆开关、优惠券开关、订单状态变化、电影卡兑换次数校验不通过提示
        const errRefesh = [6000, 1000, 1001, 1002, 2101, 2108].some((val) => {
            return val === errCode;
        });
        // 点击回首页的错误 订单不存在、价格校验错误

        const errGoIndex = [2100, 2102, 2104].some((val) => {
            return val === errCode;
        });

        if (errRefesh) {
            this.getOrder();
        }

        if (errGoIndex) {
            if (Platform.OS === 'web') {
                // location.replace(`${hostUrl}`)
                window.location.replace(`${hostUrl}`);
            } else {
                this.context.router.replace({ routeName: 'index' });
            }
        }

        /* 上述其它错误提示点确定关闭弹层 */

        this.setState({
            isErrShow: false
        });
    }

    /* 密码校验 */
    _submitShortPwd(value) {
        if (this.state.limitCount <= 0) {
            const txt = '您的支付密码连续多次输入错误，两小时后解锁。';

            this.setState({
                errorMessage: txt
            });

            return;
        }

        const password = (md5(value, 32));

        this.setState({
            inLoading: true
        });

        /* 校验密码 */
        get('checkOrderPayPwd', {
            password,
            clientIP: '10.0.0.1'
        }).then((res) => {
            const limitCount = 6 - res.data.failTimes;

            const txt = res.data.failTimes <= 5 && res.data.failTimes > 0 ? `您输入的密码错误，还有${limitCount}次机会` : '您的支付密码连续多次输入错误，两小时后解锁。';

            if (res.data.failTimes > 0) {
                this.setState({
                    inLoading: false,
                    errorMessage: txt,
                    limitCount: limitCount
                });
            } else {
                this.setState({
                    inLoading: false,
                    passwordShow: false
                });
                this._submit(password);
            }
        });

        if(!value){
            sgmReport('1001', {function_id: 'checkOrderPayPwd',message:'缺少参数password'}, 3)
        }
    }

    /* 倒计时 */
    _timeOut() {
        // TODO:临时注释，后面放开
        // this.setState({
        //     goList: false
        // });
        console.log('time out');
    }

    /* 打开价格详情 */
    _openInfo() {
        const { infoShow } = this.state;

        if (!infoShow) {
            mta('OrdRealPayPopExpo', 'OrdInput');
        }

        this.setState({
            infoShow: !infoShow
        });
    }

    /* 打开优惠券列表 */
    _selectCoupon() {
        const { isCouponError } = this.state;

        // 优惠券点击
        mta('OrdCoupon', 'OrdInput');
        // 优惠券曝光
        mta('OrdCouponPopExpo', 'OrdInput');

        if (isCouponError) {
            this.context.router.toError({ fromType: 'order' });
        } else {
            this.setState({
                couponSelectShow: true
            });
        }
    }

    /* 关闭弹层（京豆、促销、优惠券） */
    _onHide() {
        const { infoShow, couponSelectShow } = this.state;

        const mtaText = infoShow ? 'OrdRealPayPopClose' : couponSelectShow ? 'OrdCouponPopClose' : '';

        mtaText && mta(mtaText, 'OrdInput');

        this.setState({
            infoShow: false,
            couponSelectShow: false,
            couponAllShow: false
        });
    }

    /* 获取订单信息 */
    getOrder() {
        const {
            agentOrderId,
            agentId,
            price,
            userPin,
            promoDiscountPrice,
            selectCertInfo,
            seatsGroup,
            promoInfo,
            selectCertificateMap,
		        limitNumber, // 几个优惠
		        promoSeatCount, // 促销座位个数
	          scheduledPlay
        } = this.props;
        const { partition } = this.state;
        this.setState({
            loading: false
        });

        console.log('agentOrderId ', agentOrderId, ' agentId ', agentId, ' userPin ', userPin);
        /* 影片信息 */
        get('getLockInfo', {
            agentOrderId,
            agentId,
            userPin,
	          scheduledPlay: +scheduledPlay
        }).then((res) => {
            // 座位个数
            const seats = res.data?.seats?.split('|').length;
            let scaleFee = 0; // 促销总金额
            let tmpTTFee = 0; // 总票价(总金额)
            // 根据是否开启分区区别计算价格[开启了且有值];
            let paySeatPrice = 0;
            if (partition && seatsGroup.length) {
                // 这里应该使用原价
                seatsGroup.map(value=> tmpTTFee += value.originalPrice)
                // 优惠金额
                promoInfo.map(value => {
                	// 有优惠才累加
                	if (value.showPromotions) {
		                scaleFee += value.promoDiscountPrice
	                }
                });
                // 获取开启分区的优惠金额
                paySeatPrice = this.getCertFee();
            } else {
		            paySeatPrice = sub(mul(price, seats), scaleFee) / seats;
		            let discount = 0;
		            // 促销限制个数
		            if (limitNumber > 0) {
				            discount =  (promoDiscountPrice || 0) * (Number(promoSeatCount) > 0 ? Number(promoSeatCount) : 1);
		            }
								// 促销优惠价格
		            scaleFee = selectCertInfo.length > 0 ? 0 : discount;
		            const priceNumber = +price;
		            tmpTTFee = parseFloat(priceNumber * seats)
            }

            const config = {
	            loading: false,
	            orderInfo: res.data,
	            onlinePayFee: tmpTTFee - scaleFee, //在线支付价格(总金额 - 促销优惠)
	            totalFee: tmpTTFee, // 总票价(总金额)
	            minutes: res.data.minutes,
	            seconds: res.data.seconds,
	            venderId: res.data.venderId || '',
	            venderName: res.data.venderName || '',
	            scaleFee, // 促销优惠价格(促销立减金额)
	            paySeatPrice // 每个座位减去促销后的价格
            }
	          console.log('金额计算写入', config, {
	          		promoInfo,
			          seatsGroup,
			          tmpTTFee,
			          scaleFee,
			          price,
			          seats,
			          selectCertInfo
	          })
            this.setState(config);
            /* 获取优惠券 */
            this.getCoupon(config.onlinePayFee);
            /* 获取电影卡 */
            this.getCard();
            /* 获取京豆 */
            this.getJdbeans(config.onlinePayFee);
            /* 获取影豆 */
            this.getYingDou(tmpTTFee);

        }).catch(() => {
            this.setState({
                hasError: true
            });
        });

        if(!agentOrderId || !agentId || !userPin){
            sgmReport('1001', {function_id: 'getLockInfo',message:'缺少参数agentOrderId/agentId/userPin'}, 3)
        }
    }

	/**
	 *  影豆立减必须传入总金额[非优惠后]
	 * @param tmpTTFee
	 */
    getYingDou(tmpTTFee) {
        const { scaleFee } = this.state;
        get('mv_order_movieBean', {})
            .then((res) => {
                let isError = false;
                if (res?.errCode === null || res?.errCode === undefined || res?.errCode === '') {
                    isError = true;
                } else if (parseInt(res?.errCode) === 0) { // 成功
                    isError = false;
                    const { movieBeanCount } = res.data;
                    // 影豆增加优惠促减
                    const yingdouCount = (tmpTTFee - scaleFee - movieBeanCount) > 0
	                    ? movieBeanCount
	                    : (tmpTTFee - scaleFee);
                    this.setState({
                        allYingDouCount: movieBeanCount,
                        yingdouCount: yingdouCount
                    });
                } else {
                    isError = true;
                }

                if (isError) {
                    this.setState({
                        allYingDouCount: 0,
                        yingdouCount: 0,
                        isYingDouError: true
                    });
                }
            }).catch(() => {
                this.setState({
                    allYingDouCount: 0,
                    yingdouCount: 0,
                    isYingDouError: true
                });
            });
    }

    getJdbeans(totalFee) {
        /* 京豆信息 */
        get('getJingBeanInfo', {
            totalFee
        }).then((res) => {
            this.setState({
                // 可用的京豆数量（总）
                allJdbeans: res.data.balance || 0,
                // 京豆使用次数
                jdbeansCount: res.data.count || 0,
                // 订单可用京豆数量
                jdbeansNum: res.data.availableBalance || 0,
                // 不会有错
                isJdbeansError: false
            });
        }).catch(() => {
            // tip('京豆获取失败，请稍候重试...')
            this.setState({
                isJdbeansError: true,
                // 可用的京豆数量（总）
                allJdbeans: 0,
                // 京豆使用次数
                jdbeansCount: 0,
                // 订单可用京豆数量
                jdbeansNum: 0
            });
        });
    }

    getCard() {
        const { planId ,seatsGroup, scheduledPlay = "0"} = this.props;
        const promoId = this.props.promoId || 0;
        // const JMmobile = encrypt(mobileNum, 'y97c51kl38h8p144') || 0;
        /* 电影卡信息 */

        let seat;
        if(seatsGroup?.length) {    //将座位已价格从小到大排序
            seatsGroup.sort((a, b) => {
                return a["price"] - b["price"];
            });
            seat = seatsGroup[0]?.["meta"];
        }

	       const mobileNum = store.getItem('savemobile');

        get('getCerts', {
					planId,
	        mobile: mobileNum || 0,
	        promoId,
	        seat,
	        scheduledPlay: +scheduledPlay
				}).then((res) => {
            // 可用的卡
            // availableCerts
            // 当前不可用卡
            // currentUnavailableCerts
            this.props.dispatch({
                type: 'cert_num_change',
                cardNum: res.data.availableCerts ? res.data.availableCerts.length : 0
            });
            this.setState({
                loading: true
            });
        }).catch(() => {
            this.props.dispatch({
                type: 'cert_num_change',
                cardNum: 0
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });

        if(!planId){
            sgmReport('1001', {function_id: 'getCerts',message:'缺少参数planId'}, 3)
        }
    }

	/**
	 * 获取优惠券
	 * @param totalFee 票价总金额(减去优惠的金额)
	 */
    getCoupon(totalFee) {
        const { orderInfo } = this.state;
        const { planId } = this.props;

        /* 优惠券信息 */
        get('getJdCouponList', {
            totalFee,
            cinemaId: orderInfo?.cinemaId,
            planId: planId,
            // platform: 3,
            movieName: orderInfo.movieName || ''
        }, true).then((res) => {
            if (!res.data) {
                this.setState({
                    isCouponError: true
                });
            } else {
                this.setState({
                    isCouponError: false,
                    couponList: res.data
                });
            }
        }).catch(() => {
            this.setState({
                couponList: [],
                isCouponError: true
            });
        });

        if(!planId){
            sgmReport('1001', {function_id: 'getJdCouponList',message:'缺少参数planId'}, 3)
        }
    }

    _closeDialog = key => {
        this.setState({
            [key]: false
        });
    }

    _showDialog = key => {
        this.setState({
            [key]: true
        });
    }

    // 获取拼团影片信息
    handleScheduledPlay() {
        const { planId } = this.props;
        post('scheduledPlayInfo', { planId }).then(res => {
            if(res.data){
                this.setState({
                    isScheduledPlay: true,
                })
            }
        });

        if(!planId){
            sgmReport('1001', {function_id: 'scheduledPlayInfo',message:'缺少参数planId'}, 3)
        }
    }
}

const Info = (props) => {
    const { timeOut, orderInfo, theDate, startTime, seats, time } = props;

    console.log('agentOrderId seats ', seats);

    let day = getWeek(theDate);

    if (diff(theDate, trimTime(new Date())) < 2) { day = ['今天', '明天'][diff(theDate, trimTime(new Date()))]; }

    return (
        <View style={ st.top }>

            <JDText type='regular' style={ [st.mov_name, { height: 'auto' }] }>{orderInfo.movieName}</JDText>

            <JDText type='regular' style={ st.mov_info_top }>{theDate.split('-')[1]}-{theDate.split('-')[2]}({day}) | {startTime} | {orderInfo.playType} | {orderInfo.hallName}</JDText>

            <JDText style={ st.mov_info }>{orderInfo.cinemaName}</JDText>

            <JDText style={ st.mov_info }>
                {seats && seats.map((val, inx) => {
                    const seat = val.split(';')[0].split(':');

                    return (
                        <JDText key={ inx }>{seat[0]}排{complement(seat[1])}座{(inx + 1) !== seats.length ? '、' : ''} </JDText>
                    );
                })}
            </JDText>
            {/* <CountDown timeOut={timeOut} minutes={time.minutes} seconds={time.seconds} /> */}
            {(time.minutes > 0 || time.seconds > 0) && <CountDown timeOut={ timeOut } minutes={ time.minutes } seconds={ time.seconds } />}

        </View>
    );
};

const Tel = (props) => {
    const { tel } = props;

    const decodeTel = decrypt(tel, 'y97c51kl38h8p144');

    return (
        <View style={ st.tel }>

            <JDText style={ st.tel_name }>联系电话</JDText>

            <JDText style={ st.tel_txt }>
                {decodeTel.slice(0, 3) + ' ' + decodeTel.slice(3, 7) + ' ' + decodeTel.slice(7, 11)}
            </JDText>

        </View>
    );
};

const Promotion = (props) => {
    const { activityType, promotionFee, govSubsidy, govSubsidyText, govSubsidyTag } = props;

    let activeContent = "政府补贴活动立减";
    if (govSubsidyTag && govSubsidyTag === "DBC" && govSubsidyText) {
         let govSubsidyTextStr = ''
        if (govSubsidyText) {
            govSubsidyTextStr = decodeURIComponent(govSubsidyText);
        }
        activeContent = govSubsidyTextStr;
    }

    return (
        <View style={ st.all_list }>
            <View style={ st.list }>
                <View style={ st.left }>
                    <View style={ [st.v_scale, govSubsidy === 'true' ? st.greenBg : st.orange] }>
                        <JDText style={ st.scale }>惠</JDText>
                    </View>
                    <JDText style={ [st.scale_txt, govSubsidy === 'true' ? st.greenTxt : st.orange_txt] }>{govSubsidy === "true" ? activeContent : promoTxt[activityType]?.txt}</JDText>
                    {false &&
                            <View style={ st.no_coupon }>
                                <JDText style={ st.is_coupon }>无可用</JDText>
                            </View>
                    }
                </View>
                <View style={ st.left }>
                    <JDText style={ st.s_price }>-&yen;{promotionFee}</JDText>
                    {/* <JDImage source={img.right}></JDImage> */}
                </View>
            </View>

            {false && <JDTouchable onPress={ () => {} }>
                <View style={ [st.list, st.card] }>
                    <View style={ st.left }>
                        <View style={ [st.v_scale, st.bg2B84FF] }>
                            <JDText style={ st.scale }>卡</JDText>
                        </View>
                        <JDText numberOfLines={ 1 } style={ [st.scale_txt, st.blue_txt] }>暑期大套餐购买年卡立减优惠</JDText>
                    </View>
                    <View style={ st.left }>
                        <JDText style={ st.s_price }>-&yen;10</JDText>
                        {/* <JDImage source={img.right}></JDImage> */}
                    </View>
                </View>
            </JDTouchable>}

        </View>
    );
};

const Coupon = (props) => {
    const { couponNum, couponFee, selectCoupon, coupon, cardUseNum, seatsCount, isCouponError } = props;
    const labelConfig = {
        can: {
            font: { fontSize: 12, color: '#FFFFFF' },
            type: 'liner',
            style: { height: 18 },
            border: { borderRadius: 2 }
        },
        cant: {
            font: { fontSize: 12, color: '#FFFFFF' },
            style: { height: 18, backgroundColor: '#D9D9D9' },
            border: { borderRadius: 2 }
        }
    };

    return (
        <JDTouchable onPress={ selectCoupon } >
            <View style={ st.coupon }>
                <View style={ st.left }>
                    <JDText style={ st.c_txt }>京东优惠券</JDText>
                    {(isCouponError && cardUseNum === seatsCount) || couponNum <= 0
                        ? <Label { ...labelConfig.cant } name='暂无可用' />

                        : <Label { ...labelConfig.can } name={ couponFee > 0 ? `已选${coupon.length}张` : `可用${couponNum}张` } />

                    }
                </View>
                <View style={ st.left }>
                    {couponFee > 0 && <JDText style={ st.s_price }>-&yen;{couponFee}</JDText>}
                    <JDImage style={ st.right_arrow } source={ img.right } />
                </View>
            </View>
        </JDTouchable>
    );
};

const Card = (props) => {
    const { cardNum, goCardList, selectCardNum } = props;
    const labelConfig = {
        can: {
            font: { fontSize: 12, color: '#FFFFFF' },
            type: 'liner',
            style: { height: 18 },
            border: { borderRadius: 2 }
        },
        cant: {
            font: { fontSize: 12, color: '#FFFFFF' },
            style: { height: 18, backgroundColor: '#D9D9D9' },
            border: { borderRadius: 2 }
        }
    };

    return (
        <JDTouchable onPress={ goCardList } >
            <View style={ st.coupon }>
                <View style={ st.left }>
                    <JDText style={ st.c_txt }>电影兑换券</JDText>
                    {
                        cardNum <= 0
                            ? <Label { ...labelConfig.cant } name='暂无可用' />

                            : <Label { ...labelConfig.can } name={ selectCardNum > 0 ? `已选${selectCardNum}张` : `可用${cardNum}张` } />

                    }

                </View>
                <View style={ st.left }>
                    <JDImage style={ st.right_arrow } source={ img.right } />
                </View>
            </View>
        </JDTouchable>
    );
};

const Bottom = (props) => {
    const { showInfo, openInfo, submit, onlinePayFee, doSubmit } = props;
    return (
        <View style={ st.bottom }>
            <JDTouchable onPress={ openInfo }>
                {showInfo && <View style={ st.b_info }>

                    <View style={ st.eixt }>
                        {false && <View style={ st.e_info }>
                            <JDImage style={ st.e_img } source={ img.o_right } />
                            <JDText style={ st.e_text }>可改</JDText>
                        </View>}
                        {true && <View style={ st.e_info }>
                            <JDImage style={ st.e_img } source={ img.o_right_g } />
                            <JDText style={ [st.e_text, st.gray] }>不可退</JDText>
                        </View>}
                        {true && <View style={ st.e_info }>
                            <JDImage style={ st.e_img } source={ img.o_right_g } />
                            <JDText style={ [st.e_text, st.gray] }>不可改</JDText>
                        </View>}
                    </View>

                    <View style={ st.price }>
                        <JDText style={ st.t_head }>实付款:</JDText>
                        <JDText style={ st.t_pic }>&yen;</JDText>
                        <JDText style={ st.t_price }>{onlinePayFee}</JDText>
                        <JDImage style={ st.right } source={ img.o_top } />
                    </View>

                </View>}
            </JDTouchable>
            {
                doSubmit
                    ? <JDTouchable onPress={ submit } >
                        <LinearGradient colors={ ['#bbb', '#bbb', '#bbb'] } style={ st.agreen } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                            {/* <View style={st.agreen}> */}

                            <JDText style={ st.agreen_txt }>正在提交...</JDText>
                            {/* </View> */}
                        </LinearGradient>
                    </JDTouchable>
                    : <JDTouchable onPress={ submit } >
                        <LinearGradient colors={ ['#F10000', '#FF2000', '#FF4F18'] } style={ st.agreen } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                            {/* <View style={st.agreen}> */}

                            <JDText style={ st.agreen_txt }>确认支付</JDText>
                            {/* </View> */}
                        </LinearGradient>
                    </JDTouchable>
            }

        </View>
    );
};

Order.contextTypes = {
    router: PropTypes.object
};
const select = (state) => {
    const props = state.index;
    const movieCard = state.movieCard;
    const movieList = state.movieList;
    const seat = state.seat;
    const seatsGroup = fetchLocal('seatsGroup');
    const promoInfo  = fetchLocal('promoInfo');
    const selectCertificateMap = fetchLocal('selectCertificateMap');
    const certInfo = fetchLocal('certInfo');
    const config = {
        cur_city: props.cur_city,
        selectCertInfo: certInfo || movieCard.certInfo,
        cardNum: movieCard.cardNum,
        brandId: movieList.brandId,
        newUser: movieList.newUser,
        promoInfo: promoInfo || seat.promoInfo,
        seatsGroup: seatsGroup || seat.seatsGroup, // 座位和价格的对应关系
        selectCertificateMap: selectCertificateMap || movieCard.selectCertificateMap || {}, // 座位及优惠明细
    };
		console.log('config', config)
    return config;
};

export default connect(select, null, null, { withRef: true })(Order);
